import { DETAILED_STEP_DATA } from '../../data/detailed-step.data';

interface ITabHeader {
  activeTab: string;
  handleOnTabChange: (tabId: string) => void;
}

export const TabHeader = ({ activeTab, handleOnTabChange }: ITabHeader) => {
  return (
    <div className="flex">
      {DETAILED_STEP_DATA(activeTab)?.map((item) => (
        <div key={item.id} className="flex items-start sm:w-full">
          <div
            onClick={() => handleOnTabChange(item.id)}
            className={`cursor-pointer text-base font-semibold p-4 w-44 h-16 text-center sm:py-3 sm:px-4 sm:text-s-14 sm:h-12 sm:w-full ${
              activeTab === item.id
                ? 'text-blue-350 bg-[#F8FBFF] border-b-blue-350 border-b-4'
                : 'text-grey-500 border-b-4 border-b-grey-140'
            }`}
          >
            {item.title}
          </div>
        </div>
      ))}
      <div className="border-b-4 border-b-grey-140 items-end justify-end w-full h-16 sm:hidden"></div>
    </div>
  );
};
